export const P_SUBMITApi = 1;
export const PROJECT_PREVIEW_LENGTHApi = 100;
export const SERVICE_PREVIEW_LENGTHApi = 100;
export const MAX_NUMBER_OF_ES_JOBSApi = 1000;
export const RECOMMENDED_PROJECTS_MIN_BIDSApi = 0;
export const RECOMMENDED_PROJECTS_MAX_BIDSApi = 25;
export const RECOMMENDED_PROJECTS_DEFAULT_LIMITApi = 25;
export const RECOMMENDED_PROJECTS_MAX_AGEApi = 30;
export const RECOMMENDED_FREELANCERS_DEFAULT_LIMITApi = 12;
export const MAX_BID_DISTANCEApi = 150;
export const MAX_IMAGE_HEIGHTApi = 80;
export const MAX_IMAGE_WIDTHApi = 80;
export const INSIGHTS_BIDS_DEFAULT_LIMITApi = 10;
export var ProjectExceptionCodesApi;
(function (ProjectExceptionCodesApi) {
    ProjectExceptionCodesApi["EMAIL_NOT_VERIFIED"] = "email_not_verified";
    ProjectExceptionCodesApi["USER_SUSPENDED"] = "user_suspended";
    ProjectExceptionCodesApi["DAO_EXCEPTION"] = "dao_exception";
    ProjectExceptionCodesApi["DB_EXCEPTION"] = "db_exception";
    ProjectExceptionCodesApi["IDENTITY_EXCEPTION"] = "identity_exception";
    ProjectExceptionCodesApi["GAF_EXCEPTION"] = "gaf_exception";
    ProjectExceptionCodesApi["INVALID_REQUEST"] = "invalid_request";
    ProjectExceptionCodesApi["UNHANDLED_EXCEPTION"] = "unhandled_exception";
    ProjectExceptionCodesApi["UNKNOWN_ERROR"] = "unknown_error";
    ProjectExceptionCodesApi["INVALID_EMAIL"] = "invalid_email";
    ProjectExceptionCodesApi["USER_NOT_FOUND"] = "user_not_found";
    ProjectExceptionCodesApi["PROJECT_TITLE_EDIT_REQUEST_DUPLICATE"] = "project_title_edit_request_duplicate";
    ProjectExceptionCodesApi["PROJECT_TITLE_EDIT_REQUEST_NOT_PENDING"] = "project_title_edit_request_not_pending";
    ProjectExceptionCodesApi["UNVERIFIED_PAYMENT"] = "unverified_payment";
    ProjectExceptionCodesApi["DUPLICATE_PROJECT"] = "duplicate_project";
    ProjectExceptionCodesApi["NEGATIVE_BALANCE"] = "negative_balance";
    ProjectExceptionCodesApi["DUPLICATE_AWARD"] = "duplicate_award";
    ProjectExceptionCodesApi["DUPLICATE_BID"] = "duplicate_bid";
    ProjectExceptionCodesApi["BID_FIELDS_MISSING"] = "bid_fields_missing";
    ProjectExceptionCodesApi["BID_ALREADY_RETRACTED"] = "bid_already_retracted";
    ProjectExceptionCodesApi["BID_ALREADY_HIGHLIGHTED"] = "bid_already_highlighted";
    ProjectExceptionCodesApi["RESTRICTED_FROM_BIDDING"] = "restricted_from_bidding";
    ProjectExceptionCodesApi["PROJECT_MAX_HIGHLIGHTS"] = "project_max_highlights";
    ProjectExceptionCodesApi["BID_DESCRIPTION_INVALID"] = "bid_description_invalid";
    ProjectExceptionCodesApi["BIDDER_NOT_QUALIFIED"] = "bidder_not_qualified";
    ProjectExceptionCodesApi["BIDDER_NOT_INVITED"] = "bidder_not_invited";
    ProjectExceptionCodesApi["NDA_NOT_SIGNED"] = "nda_not_signed";
    ProjectExceptionCodesApi["BIDDER_OWNS_PROJECT"] = "bidder_owns_project";
    ProjectExceptionCodesApi["SKILLS_REQUIREMENT_NOT_MET"] = "skills_requirement_not_met";
    ProjectExceptionCodesApi["INVALID_PROJECT"] = "invalid_project";
    ProjectExceptionCodesApi["INVALID_BID"] = "invalid_bid";
    ProjectExceptionCodesApi["PROJECT_NOT_ACTIVE"] = "project_not_active";
    ProjectExceptionCodesApi["PROJECT_DELETED"] = "project_deleted";
    ProjectExceptionCodesApi["BID_AWARD_PENDING"] = "bid_award_pending";
    ProjectExceptionCodesApi["BID_CANCELLED_BY_ADMIN"] = "bid_cancelled_by_admin";
    ProjectExceptionCodesApi["NEGATIVE_SPONSOR_AMOUNT"] = "negative_sponsor_amount";
    ProjectExceptionCodesApi["SPONSOR_AMOUNT_BELOW_MINIMUM"] = "sponsor_amount_below_minimum";
    ProjectExceptionCodesApi["SPONSOR_AMOUNT_INSUFFICIENT_INCREASE"] = "sponsor_amount_insufficient_increase";
    ProjectExceptionCodesApi["SPONSOR_AMOUNT_BELOW_PREVIOUS"] = "sponsor_amount_below_previous";
    ProjectExceptionCodesApi["BID_LIMIT_EXCEEDED"] = "bid_limit_exceeded";
    ProjectExceptionCodesApi["BID_PERIOD_INVALID"] = "bid_period_invalid";
    ProjectExceptionCodesApi["BID_DESCRIPTION_CONTAINS_EMAIL"] = "bid_description_contains_email";
    ProjectExceptionCodesApi["BID_DESCRIPTION_LENGTH_INVALID"] = "bid_description_length_invalid";
    ProjectExceptionCodesApi["BID_AMOUNT_INVALID"] = "bid_amount_invalid";
    ProjectExceptionCodesApi["BID_MILESTONE_INVALID"] = "bid_milestone_invalid";
    ProjectExceptionCodesApi["MILESTONE_REQUEST_PENDING"] = "milestone_request_pending";
    ProjectExceptionCodesApi["FREELANCER_ACCOUNT_UNDER_REVIEW"] = "freelancer_account_under_review";
    ProjectExceptionCodesApi["MANDATORY_MILESTONE_AWARD_NOT_SUPPORTED"] = "mandatory_milestone_award_not_supported";
    ProjectExceptionCodesApi["MAXIMUM_AWARDED_BIDDERS_REACHED"] = "maximum_awarded_bidders_reached";
    ProjectExceptionCodesApi["FREELANCER_ALREADY_AWARDED"] = "freelancer_already_awarded";
    ProjectExceptionCodesApi["NO_VALID_BID_ON_PROJECT"] = "no_valid_bid_on_project";
    ProjectExceptionCodesApi["PROJECT_CLOSED"] = "project_closed";
    ProjectExceptionCodesApi["BID_DOESNT_EXIST"] = "bid_doesnt_exist";
    ProjectExceptionCodesApi["NEGATIVE_MILESTONE_REQUEST_AMOUNT"] = "negative_milestone_request_amount";
    ProjectExceptionCodesApi["MILESTONE_REQUEST_DESCRIPTION_INVALID_LENGTH"] = "milestone_request_description_invalid_length";
    ProjectExceptionCodesApi["UNAUTHORIZED_MILESTONE_REQUEST"] = "unauthorized_milestone_request";
    ProjectExceptionCodesApi["INVALID_MILESTONE_REQUEST"] = "invalid_milestone_request";
    ProjectExceptionCodesApi["PROJECT_NOT_AWARDED"] = "project_not_awarded";
    ProjectExceptionCodesApi["INVALID_MILESTONE_AMOUNT"] = "invalid_milestone_amount";
    ProjectExceptionCodesApi["INVALID_MILESTONE_AMOUNT_FORMAT"] = "invalid_milestone_amount_format";
    ProjectExceptionCodesApi["INSUFFICIENT_MILESTONE_FUNDS"] = "insufficient_milestone_funds";
    ProjectExceptionCodesApi["INVALID_MILESTONE_TRANSACTION"] = "invalid_milestone_transaction";
    ProjectExceptionCodesApi["NEGATIVE_PROJECT_COMMITMENT_HOURS_AMOUNT"] = "negative_project_commitment_hours_amount";
    ProjectExceptionCodesApi["INVALID_PROJECT_COMMITMENT_HOURS_AMOUNT"] = "invalid_project_commitment_hours_amount";
    ProjectExceptionCodesApi["INVALID_PROJECT_PERIOD_INTERVAL"] = "invalid_project_period_interval";
    ProjectExceptionCodesApi["NEGATIVE_MINIMUM_PROJECT_BUDGET"] = "negative_minimum_project_budget";
    ProjectExceptionCodesApi["INVALID_MINIMUM_PROJECT_BUDGET"] = "invalid_minimum_project_budget";
    ProjectExceptionCodesApi["MINIMUM_PROJECT_BUDGET_MISSING"] = "minimum_project_budget_missing";
    ProjectExceptionCodesApi["NEGATIVE_MAXIMUM_PROJECT_BUDGET"] = "negative_maximum_project_budget";
    ProjectExceptionCodesApi["INVALID_MAXIMUM_PROJECT_BUDGET"] = "invalid_maximum_project_budget";
    ProjectExceptionCodesApi["PROJECT_MAXIMUM_BUDGET_LESS_THAN_MINIMUM_BUDGET"] = "project_maximum_budget_less_than_minimum_budget";
    ProjectExceptionCodesApi["CONTACT_DETAILS_IN_PROJECT_TITLE"] = "contact_details_in_project_title";
    ProjectExceptionCodesApi["EMPTY_PROJECT_TITLE"] = "empty_project_title";
    ProjectExceptionCodesApi["CONTACT_DETAILS_IN_PROJECT_DESCRIPTION"] = "contact_details_in_project_description";
    ProjectExceptionCodesApi["EMPTY_PROJECT_DESCRIPTION"] = "empty_project_description";
    ProjectExceptionCodesApi["INVALID_PROJECT_CURRENCY"] = "invalid_project_currency";
    ProjectExceptionCodesApi["INVALID_PROJECT_JOB_ID"] = "invalid_project_job_id";
    ProjectExceptionCodesApi["INVALID_PROJECT_LANGUAGE_CODE"] = "invalid_project_language_code";
    ProjectExceptionCodesApi["PROJECT_MISSING_JOBS"] = "project_missing_jobs";
    ProjectExceptionCodesApi["PROJECT_EXCEED_MAX_JOBS"] = "project_exceed_max_jobs";
    ProjectExceptionCodesApi["PROJECT_INVALID_DURATION"] = "project_invalid_duration";
    ProjectExceptionCodesApi["HIREME_SAME_SELLER_BUYER"] = "hireme_same_seller_buyer";
    ProjectExceptionCodesApi["HIREME_INVALID_SELLER_ID"] = "hireme_invalid_seller_id";
    ProjectExceptionCodesApi["HIREME_INVALID_PROJECT_TYPE"] = "hireme_invalid_project_type";
    ProjectExceptionCodesApi["HIREME_INVALID_CURRENCY_ID"] = "hireme_invalid_currency_id";
    ProjectExceptionCodesApi["HIREME_BID_AMOUNT_TOO_SMALL"] = "hireme_bid_amount_too_small";
    ProjectExceptionCodesApi["HIREME_BID_AMOUNT_TOO_BIG"] = "hireme_bid_amount_too_big";
    ProjectExceptionCodesApi["HIREME_INVALID_PERIOD"] = "hireme_invalid_period";
    ProjectExceptionCodesApi["HIREME_INVALID_COMMITMENT_INTERVAL"] = "hireme_invalid_commitment_interval";
    ProjectExceptionCodesApi["HIREME_INVALID_COMMITMENT"] = "hireme_invalid_commitment";
    ProjectExceptionCodesApi["HIREME_INVALID_DURATION"] = "hireme_invalid_duration";
    ProjectExceptionCodesApi["HIREME_INVALID_JOB_ID"] = "hireme_invalid_job_id";
    ProjectExceptionCodesApi["HIREME_PROJECT_NO_JOBS"] = "hireme_project_no_jobs";
    ProjectExceptionCodesApi["HIREME_FREELANCER_HAS_NO_JOBS"] = "hireme_freelancer_has_no_jobs";
    ProjectExceptionCodesApi["HIREME_PROJECT_POST_LIMIT_EXCEEDED"] = "hireme_project_post_limit_exceeded";
    ProjectExceptionCodesApi["HIREME_CONTACT_DETAILS_IN_PROJECT_TITLE"] = "hireme_contact_details_in_project_title";
    ProjectExceptionCodesApi["HIREME_EMPTY_PROJECT_TITLE"] = "hireme_empty_project_title";
    ProjectExceptionCodesApi["HIREME_CONTACT_DETAILS_IN_PROJECT_DESCRIPTION"] = "hireme_contact_details_in_project_description";
    ProjectExceptionCodesApi["HIREME_EMPTY_PROJECT_DESCRIPTION"] = "hireme_empty_project_description";
    ProjectExceptionCodesApi["HIREME_INITIAL_BID_MISSING"] = "hireme_initial_bid_missing";
    ProjectExceptionCodesApi["HIREME_BID_MISSING_AMOUNT"] = "hireme_bid_missing_amount";
    ProjectExceptionCodesApi["HIREME_DUPLICATE_PROJECT_TITLE"] = "hireme_duplicate_project_title";
    ProjectExceptionCodesApi["HIREME_NEGATIVE_BID_AMOUNT"] = "hireme_negative_bid_amount";
    ProjectExceptionCodesApi["FREELANCER_ALREADY_INVITED"] = "freelancer_already_invited";
    ProjectExceptionCodesApi["INVITATION_LIMIT_REACHED"] = "invitation_limit_reached";
    ProjectExceptionCodesApi["INVITE_FREELANCER_INVALID_PROJECT"] = "invite_freelancer_invalid_project";
    ProjectExceptionCodesApi["UNAUTHORIZED_MILESTONE"] = "unauthorized_milestone";
    ProjectExceptionCodesApi["INVALID_MILESTONE"] = "invalid_milestone";
    ProjectExceptionCodesApi["MILESTONE_AMOUNT_GREATER_THAN_ORIGINAL"] = "milestone_amount_greater_than_original";
    ProjectExceptionCodesApi["MILESTONE_AMOUNT_EQUAL_OR_LESS_THAN_ZERO"] = "milestone_amount_equal_or_less_than_zero";
    ProjectExceptionCodesApi["INTERNAL_ESCROW_UPDATE_AMOUNT_FAILURE"] = "internal_escrow_update_amount_failure";
    ProjectExceptionCodesApi["INTERNAL_ESCROW_CREATE_FAILURE"] = "internal_escrow_create_failure";
    ProjectExceptionCodesApi["INTERNAL_SAVE_CLEAR_ESCROW_FAILURE"] = "internal_save_clear_escrow_failure";
    ProjectExceptionCodesApi["INTERNAL_ESCROW_PARAMETER_FAILURE"] = "internal_escrow_parameter_failure";
    ProjectExceptionCodesApi["PROJECT_NOT_ACCEPTED"] = "project_not_accepted";
    ProjectExceptionCodesApi["MILESTONE_IN_DISPUTE"] = "milestone_in_dispute";
    ProjectExceptionCodesApi["PENDING_BID_REQUIRED"] = "pending_bid_required";
    ProjectExceptionCodesApi["UNAUTHORIZED_MILESTONE_VIEW"] = "unauthorized_milestone_view";
    ProjectExceptionCodesApi["BID_DOES_NOT_BELONG_TO_PROJECT"] = "bid_does_not_belong_to_project";
    ProjectExceptionCodesApi["PRIVATE_MESSAGE_SEND_FAILED"] = "private_message_send_failed";
    ProjectExceptionCodesApi["UNKNOWN_SENDER_ID"] = "unknown_sender_id";
    ProjectExceptionCodesApi["ACCOUNT_DETAILS_UPDATE_REQUIRED"] = "account_details_update_required";
    ProjectExceptionCodesApi["MILESTONE_ALREADY_REQUESTED"] = "milestone_already_requested";
    ProjectExceptionCodesApi["UNAUTHORIZED_MILESTONE_RELEASE"] = "unauthorized_milestone_release";
    ProjectExceptionCodesApi["EMPTY_MILESTONE_REQUEST_DESCRIPTION"] = "empty_milestone_request_description";
    ProjectExceptionCodesApi["MILESTONE_REQUEST_CREATE_FAILED"] = "milestone_request_create_failed";
    ProjectExceptionCodesApi["MILESTONE_REQUEST_SAVE_FAILED"] = "milestone_request_save_failed";
    ProjectExceptionCodesApi["UNAUTHORIZED_PROJECT_FOR_MILESTONE"] = "unauthorized_project_for_milestone";
    ProjectExceptionCodesApi["MILESTONE_REQUEST_LOAD_FAILURE"] = "milestone_request_load_failure";
    ProjectExceptionCodesApi["INVALID_REJECT_PARAMETER"] = "invalid_reject_parameter";
    ProjectExceptionCodesApi["INVALID_DELETE_PARAMETER"] = "invalid_delete_parameter";
    ProjectExceptionCodesApi["INVALID_PAYMENT_REASON"] = "invalid_payment_reason";
    ProjectExceptionCodesApi["INSUFFICIENT_TRANSACTION_FUNDS"] = "insufficient_transaction_funds";
    ProjectExceptionCodesApi["PAYMENT_SENDER_USERID_ERROR"] = "payment_sender_userid_error";
    ProjectExceptionCodesApi["INVALID_MILESTONE_REQUEST_DESCRIPTION"] = "invalid_milestone_request_description";
    ProjectExceptionCodesApi["PROJECT_NDA_ALREADY_SIGNED"] = "project_nda_already_signed";
    ProjectExceptionCodesApi["REVIEW_ACTION_NOT_ALLOWED"] = "review_action_not_allowed";
    ProjectExceptionCodesApi["REVIEW_ACTION_FAILED"] = "review_action_failed";
    ProjectExceptionCodesApi["REVIEW_DATA_INVALID"] = "review_data_invalid";
    ProjectExceptionCodesApi["REVIEW_RATING_INVALID"] = "review_rating_invalid";
    ProjectExceptionCodesApi["REVIEW_PROJECT_ID_INVALID"] = "review_project_id_invalid";
    ProjectExceptionCodesApi["REVIEW_INSUFFICIENT_FUNDS"] = "review_insufficient_funds";
    ProjectExceptionCodesApi["REVIEW_PROJECT_NOT_HOURLY"] = "review_project_not_hourly";
    ProjectExceptionCodesApi["REVIEW_INVALID_INVOICE_ID"] = "review_invalid_invoice_id";
    ProjectExceptionCodesApi["REVIEW_INVOICE_DOES_NOT_EXIST"] = "review_invoice_does_not_exist";
    ProjectExceptionCodesApi["REVIEW_INVOICE_MISMATCH_PROJECT"] = "review_invoice_mismatch_project";
    ProjectExceptionCodesApi["REVIEW_INVOICE_MISMATCH_USER"] = "review_invoice_mismatch_user";
    ProjectExceptionCodesApi["REVIEW_INVOICE_UNPAID"] = "review_invoice_unpaid";
    ProjectExceptionCodesApi["REVIEW_COMMENT_INVALID"] = "review_comment_invalid";
    ProjectExceptionCodesApi["REVIEW_PROJECT_UNPAID"] = "review_project_unpaid";
    ProjectExceptionCodesApi["REVIEW_PROJECT_POST_LIMIT_EXCEEDED"] = "review_project_post_limit_exceeded";
    ProjectExceptionCodesApi["REVIEW_ALREADY_RATED_USER"] = "review_already_rated_user";
    ProjectExceptionCodesApi["REVIEW_FROM_USER_ID_INVALID"] = "review_from_user_id_invalid";
    ProjectExceptionCodesApi["REVIEW_TO_USER_ID_INVALID"] = "review_to_user_id_invalid";
    ProjectExceptionCodesApi["REVIEW_TYPE_INVALID"] = "review_type_invalid";
    ProjectExceptionCodesApi["PROJECT_ACTION_NOT_ALLOWED"] = "project_action_not_allowed";
    ProjectExceptionCodesApi["EMPLOYER_ACCOUNT_UNDER_REVIEW"] = "employer_account_under_review";
    ProjectExceptionCodesApi["PROJECT_UPGRADE_INSUFFICIENT_FUNDS"] = "project_upgrade_insufficient_funds";
    ProjectExceptionCodesApi["PROJECT_UPGRADE_DUPLICATE_UPGRADE"] = "project_upgrade_duplicate_upgrade";
    ProjectExceptionCodesApi["MILESTONE_REQUEST_DELETED"] = "milestone_request_deleted";
    ProjectExceptionCodesApi["MILESTONE_REQUEST_REJECTED"] = "milestone_request_rejected";
    ProjectExceptionCodesApi["MILESTONE_REQUEST_CREATED"] = "milestone_request_created";
    ProjectExceptionCodesApi["MILESTONE_REQUEST_UPDATE_FAILED"] = "milestone_request_update_failed";
    ProjectExceptionCodesApi["UNLISTED_NOT_PREFERRED"] = "unlisted_not_preferred";
    ProjectExceptionCodesApi["BIDDER_OUT_OF_RANGE"] = "bidder_out_of_range";
    ProjectExceptionCodesApi["EMAIL_VERIFICATION_REQUIRED"] = "email_verification_required";
    ProjectExceptionCodesApi["MUST_RESPOND_TO_EXISTING_PROJECT_AWARD"] = "must_respond_to_existing_project_award";
    ProjectExceptionCodesApi["PROJECT_DESCRIPTION_INVALID_LENGTH"] = "project_description_invalid_length";
    ProjectExceptionCodesApi["SERVICE_NOT_FOUND"] = "service_not_found";
    ProjectExceptionCodesApi["SERVICE_NOT_AVAILABLE"] = "service_not_available";
    ProjectExceptionCodesApi["SERVICE_INVALID_EXTRA"] = "service_invalid_extra";
    ProjectExceptionCodesApi["SERVICE_NO_EXTRAS"] = "service_no_extras";
    ProjectExceptionCodesApi["SERVICE_NO_AVAILABLE_PROVIDERS"] = "service_no_available_providers";
    ProjectExceptionCodesApi["SERVICE_NO_LOCAL_PROVIDERS"] = "service_no_local_providers";
    ProjectExceptionCodesApi["SERVICE_LOCATION_NOT_SET"] = "service_location_not_set";
    ProjectExceptionCodesApi["HOURLY_CONTRACT_CREATION_FAILED"] = "hourly_contract_creation_failed";
    ProjectExceptionCodesApi["RESTRICTED_FROM_BIDDING_PREMIUM"] = "restricted_from_bidding_premium";
    ProjectExceptionCodesApi["HIREME_INVALID_PROJECT_DESCRIPTION_LENGTH"] = "hireme_invalid_project_description_length";
    ProjectExceptionCodesApi["IMAGE_THUMBNAIL_CREATION_FAILED"] = "image_thumbnail_creation_failed";
    ProjectExceptionCodesApi["USER_RESTRICTED_FROM_AWARDING"] = "user_restricted_from_awarding";
    ProjectExceptionCodesApi["FREELANCER_RESTRICTED_FROM_BEING_AWARDED"] = "freelancer_restricted_from_being_awarded";
    ProjectExceptionCodesApi["MILESTONE_RELEASE_RESTRICTED"] = "milestone_release_restricted";
    ProjectExceptionCodesApi["UNAUTHORIZED_USER"] = "unauthorized_user";
    ProjectExceptionCodesApi["INVALID_MILESTONE_DESCRIPTION"] = "invalid_milestone_description";
    ProjectExceptionCodesApi["PROJECT_LOCATION_UPDATE_FAILED"] = "project_location_update_failed";
    ProjectExceptionCodesApi["EXPERT_GUARANTEE_FAILED_UNLOCK"] = "expert_guarantee_failed_unlock";
    ProjectExceptionCodesApi["EXPERT_GUARANTEE_FAILED_STATUS_UPDATE"] = "expert_guarantee_failed_status_update";
    ProjectExceptionCodesApi["EXPERT_GUARANTEE_NOT_LOADED"] = "expert_guarantee_not_loaded";
    ProjectExceptionCodesApi["BID_RETRACTED"] = "bid_retracted";
    ProjectExceptionCodesApi["TASK_CREATE_DAO_FAILED"] = "task_create_dao_failed";
    ProjectExceptionCodesApi["CREATE_REQUEST_DAO_FAILED"] = "create_request_dao_failed";
    ProjectExceptionCodesApi["APPROVE_REQUEST_DAO_FAILED"] = "approve_request_dao_failed";
    ProjectExceptionCodesApi["REJECT_REQUEST_DAO_FAILED"] = "reject_request_dao_failed";
    ProjectExceptionCodesApi["REQUEST_REVIEW_DAO_FAILED"] = "request_review_dao_failed";
    ProjectExceptionCodesApi["COMPLETE_DAO_FAILED"] = "complete_dao_failed";
    ProjectExceptionCodesApi["ADD_COMMENT_DAO_FAILED"] = "add_comment_dao_failed";
    ProjectExceptionCodesApi["UPDATE_COMMENT_DAO_FAILED"] = "update_comment_dao_failed";
    ProjectExceptionCodesApi["ADD_ATTACHMENT_DAO_FAILED"] = "add_attachment_dao_failed";
    ProjectExceptionCodesApi["HANDLE_PARTIAL_RELEASE_DAO_FAILED"] = "handle_partial_release_dao_failed";
    ProjectExceptionCodesApi["FAILED_LOADING_TASK"] = "failed_loading_task";
    ProjectExceptionCodesApi["NULL_FIELDS"] = "null_fields";
    ProjectExceptionCodesApi["INVALID_MILESTONE_ID"] = "invalid_milestone_id";
    ProjectExceptionCodesApi["INVALID_MILESTONE_REQUEST_ID"] = "invalid_milestone_request_id";
    ProjectExceptionCodesApi["INVALID_BID_ID"] = "invalid_bid_id";
    ProjectExceptionCodesApi["INVALID_PROJECT_ID"] = "invalid_project_id";
    ProjectExceptionCodesApi["INVALID_STATUS_CHANGE"] = "invalid_status_change";
    ProjectExceptionCodesApi["FAILED_LOADING_COMMENT"] = "failed_loading_comment";
    ProjectExceptionCodesApi["INVALID_PROJECT_TASK_ID"] = "invalid_project_task_id";
    ProjectExceptionCodesApi["NO_TASK_ID"] = "no_task_id";
    ProjectExceptionCodesApi["INVALID_AUTHOR_ID"] = "invalid_author_id";
    ProjectExceptionCodesApi["INVALID_ACTION"] = "invalid_action";
    ProjectExceptionCodesApi["COMMENT_TOO_LONG"] = "comment_too_long";
    ProjectExceptionCodesApi["INVALID_ATTACHMENT_ID"] = "invalid_attachment_id";
    ProjectExceptionCodesApi["INVALID_COMMENT_ID"] = "invalid_comment_id";
    ProjectExceptionCodesApi["TASK_NOT_FOUND"] = "task_not_found";
    ProjectExceptionCodesApi["NO_COMMENT_ID"] = "no_comment_id";
    ProjectExceptionCodesApi["FILE_NOT_FOUND"] = "file_not_found";
    ProjectExceptionCodesApi["INVALID_FILE_CREATOR"] = "invalid_file_creator";
    ProjectExceptionCodesApi["INVALID_FILE_PROJECT"] = "invalid_file_project";
    ProjectExceptionCodesApi["UNRECOGNISED_STATUS"] = "unrecognised_status";
    ProjectExceptionCodesApi["UPSERT_TASK_FAILED"] = "upsert_task_failed";
    ProjectExceptionCodesApi["UPSERT_COMMENT_FAILED"] = "upsert_comment_failed";
    ProjectExceptionCodesApi["UPSERT_ATTACHMENT_FAILED"] = "upsert_attachment_failed";
    ProjectExceptionCodesApi["ATTACHMENTS_WITHOUT_COMMENTS"] = "attachments_without_comments";
    ProjectExceptionCodesApi["TASK_GET_BY_ID_FAILED"] = "task_get_by_id_failed";
    ProjectExceptionCodesApi["COMMENT_GET_BY_ID_FAILED"] = "comment_get_by_id_failed";
    ProjectExceptionCodesApi["ATTACHMENT_GET_BY_ID_FAILED"] = "attachment_get_by_id_failed";
    ProjectExceptionCodesApi["CONVERT_TO_THRIFT_FAILED"] = "convert_to_thrift_failed";
    ProjectExceptionCodesApi["PUNCH_CHECKSUM_INVALID"] = "punch_checksum_invalid";
    ProjectExceptionCodesApi["HOURLY_CONTRACT_NOT_FOUND"] = "hourly_contract_not_found";
    ProjectExceptionCodesApi["HOURLY_CONTRACT_NOT_AUTOPAID"] = "hourly_contract_not_autopaid";
    ProjectExceptionCodesApi["DUPLICATE_PROJECT_ATTACHMENT"] = "duplicate_project_attachment";
    ProjectExceptionCodesApi["PROJECT_UPGRADE_CURRENCY_REQUIRED"] = "project_upgrade_currency_required";
    ProjectExceptionCodesApi["BID_INVALID_HOURLY_RATE"] = "bid_invalid_hourly_rate";
    ProjectExceptionCodesApi["BID_BELOW_MINIMUM_HOURLY_RATE"] = "bid_below_minimum_hourly_rate";
    ProjectExceptionCodesApi["BID_USER_IS_NOT_BIDDER"] = "bid_user_is_not_bidder";
    ProjectExceptionCodesApi["BID_USER_MUST_BE_BIDDER_OR_EMPLOYER"] = "bid_user_must_be_bidder_or_employer";
    ProjectExceptionCodesApi["BID_INVALID_USER_ID"] = "bid_invalid_user_id";
    ProjectExceptionCodesApi["RESTRICTED_FROM_BIDDING_ON_FEATURED"] = "restricted_from_bidding_on_featured";
    ProjectExceptionCodesApi["INVALID_TEAM_OWNER_MEMBER"] = "invalid_team_owner_member";
    ProjectExceptionCodesApi["PHONE_VERIFICATION_REQUIRED"] = "phone_verification_required";
    ProjectExceptionCodesApi["HIREME_SELLER_LOAD_FAILED"] = "hireme_seller_load_failed";
    ProjectExceptionCodesApi["HIREME_BUYER_LOAD_FAILED"] = "hireme_buyer_load_failed";
    ProjectExceptionCodesApi["LATITUDE_INVALID"] = "latitude_invalid";
    ProjectExceptionCodesApi["LONGITUDE_INVALID"] = "longitude_invalid";
    ProjectExceptionCodesApi["IP_AGREEMENT_NOT_SIGNED"] = "ip_agreement_not_signed";
    ProjectExceptionCodesApi["RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED"] = "restricted_from_bidding_premium_verified";
    ProjectExceptionCodesApi["PROJECT_SOURCE_NOT_FOUND"] = "project_source_not_found";
    ProjectExceptionCodesApi["FAILED_TO_ADD_NEW_USER"] = "failed_to_add_new_user";
    ProjectExceptionCodesApi["FAILED_TO_ADD_EXISTING_USER"] = "failed_to_add_existing_user";
    ProjectExceptionCodesApi["FAILED_TO_LOAD_PROJECT"] = "failed_to_load_project";
    ProjectExceptionCodesApi["FAILED_TO_LOAD_EMPLOYER"] = "failed_to_load_employer";
    ProjectExceptionCodesApi["FAILED_TO_OBSCURE_EMAIL"] = "failed_to_obscure_email";
    ProjectExceptionCodesApi["FAILED_TO_LOAD_COLLABORATOR"] = "failed_to_load_collaborator";
    ProjectExceptionCodesApi["COLLABORATOR_CANNOT_BE_BIDDER"] = "collaborator_cannot_be_bidder";
    ProjectExceptionCodesApi["COLLABORATOR_CANNOT_BE_OWNER"] = "collaborator_cannot_be_owner";
    ProjectExceptionCodesApi["COLLABORATOR_ALREADY_ADDED"] = "collaborator_already_added";
    ProjectExceptionCodesApi["FAILED_TO_DEACTIVATE_COLLABORATION"] = "failed_to_deactivate_collaboration";
    ProjectExceptionCodesApi["FAILED_TO_UPDATE_COLLABORATION_PERMISSIONS"] = "failed_to_update_collaboration_permissions";
    ProjectExceptionCodesApi["TIME_TRACKING_STOPPED"] = "time_tracking_stopped";
    ProjectExceptionCodesApi["PROJECT_ID_REQUIRED"] = "project_id_required";
    ProjectExceptionCodesApi["PROJECT_NOT_FOUND"] = "project_not_found";
    ProjectExceptionCodesApi["INVOICE_ID_REQUIRED"] = "invoice_id_required";
    ProjectExceptionCodesApi["AUTOMATIC_BILLING_UPDATE_CONTRACT_DAO_FAILED"] = "automatic_billing_update_contract_dao_failed";
    ProjectExceptionCodesApi["AUTOMATIC_BILLING_UNAUTHORIZED"] = "automatic_billing_unauthorized";
    ProjectExceptionCodesApi["AUTOMATIC_BILLING_INVALID_BID"] = "automatic_billing_invalid_bid";
    ProjectExceptionCodesApi["AUTOMATIC_BILLING_INVALID_USER"] = "automatic_billing_invalid_user";
    ProjectExceptionCodesApi["AUTOMATIC_BILLING_TIME_TRACKING_IS_ENABLED"] = "automatic_billing_time_tracking_is_enabled";
    ProjectExceptionCodesApi["AUTOMATIC_BILLING_EXISTING_UNPAID_INVOICE"] = "automatic_billing_existing_unpaid_invoice";
    ProjectExceptionCodesApi["AUTOMATIC_BILLING_UNVERIFIED_PAYMENT"] = "automatic_billing_unverified_payment";
    ProjectExceptionCodesApi["AUTOMATIC_BILLING_PENDING_DISPUTE_MILESTONE"] = "automatic_billing_pending_dispute_milestone";
    ProjectExceptionCodesApi["WEEKLY_LIMIT_LESS_THAN_CURRENT_TRACKED_HOURS"] = "weekly_limit_less_than_current_tracked_hours";
    ProjectExceptionCodesApi["WEEKLY_LIMIT_IS_INVALID"] = "weekly_limit_is_invalid";
    ProjectExceptionCodesApi["BID_IS_NOT_AWARDED"] = "bid_is_not_awarded";
    ProjectExceptionCodesApi["BID_NOT_FOUND"] = "bid_not_found";
    ProjectExceptionCodesApi["HOURLY_CONTRACT_ACTION_UNAUTHORIZED"] = "hourly_contract_action_unauthorized";
    ProjectExceptionCodesApi["TIME_TRACKING_OUTSIDE_BILLING_CYCLE"] = "time_tracking_outside_billing_cycle";
    ProjectExceptionCodesApi["PROJECT_USER_RESTRICTED"] = "project_user_restricted";
    ProjectExceptionCodesApi["HIREME_EMPLOYER_RESTRICTED"] = "hireme_employer_restricted";
    ProjectExceptionCodesApi["SHARE_PROJECT_LIMIT_REACHED"] = "share_project_limit_reached";
    ProjectExceptionCodesApi["SHARE_PROJECT_DAILY_LIMIT_REACHED"] = "share_project_daily_limit_reached";
    ProjectExceptionCodesApi["SHARE_PROJECT_CLOSED_PROJECT"] = "share_project_closed_project";
    ProjectExceptionCodesApi["BID_TOO_EARLY"] = "bid_too_early";
    ProjectExceptionCodesApi["RESTRICTED_FROM_BIDDING_PREMIUM_VERIFIED_JOB"] = "restricted_from_bidding_premium_verified_job";
    ProjectExceptionCodesApi["CHARGE_PROJECT_FEE_INSUFFICIENT_FUND"] = "charge_project_fee_insufficient_fund";
    ProjectExceptionCodesApi["FAILED_TO_GET_COLLABORATION_BY_ID"] = "failed_to_get_collaboration_by_id";
    ProjectExceptionCodesApi["NOT_ACTIVE_COLLABORATOR"] = "not_active_collaborator";
    ProjectExceptionCodesApi["FAILED_TO_LOAD_CONTEST"] = "failed_to_load_contest";
    ProjectExceptionCodesApi["COLLABORATOR_CANNOT_HAVE_ENTRY"] = "collaborator_cannot_have_entry";
    ProjectExceptionCodesApi["COLLABORATION_INVALID_PERMISSION"] = "collaboration_invalid_permission";
    ProjectExceptionCodesApi["COLLABORATION_INVALID_USER_ID"] = "collaboration_invalid_user_id";
    ProjectExceptionCodesApi["COLLABORATION_INVALID_STATUS"] = "collaboration_invalid_status";
    ProjectExceptionCodesApi["SUPPORT_SESSION_INVALID"] = "support_session_invalid";
    ProjectExceptionCodesApi["DEPOSIT_FEE_INVALID"] = "deposit_fee_invalid";
    ProjectExceptionCodesApi["DEPOSIT_METHOD_INVALID"] = "deposit_method_invalid";
    ProjectExceptionCodesApi["DEPOSIT_CANCEL_URL_INVALID"] = "deposit_cancel_url_invalid";
    ProjectExceptionCodesApi["DEPOSIT_SETUP_FAIL"] = "deposit_setup_fail";
    ProjectExceptionCodesApi["DEPOSIT_API_FAIL"] = "deposit_api_fail";
    ProjectExceptionCodesApi["DEPOSIT_ALREADY_BILLING_AGREEMENT"] = "deposit_already_billing_agreement";
    ProjectExceptionCodesApi["DEPOSIT_INVOICE_INVALID"] = "deposit_invoice_invalid";
    ProjectExceptionCodesApi["DEPOSIT_ALREADY_CONFIRMED"] = "deposit_already_confirmed";
    ProjectExceptionCodesApi["DEPOSIT_CONFIRM_FAIL"] = "deposit_confirm_fail";
    ProjectExceptionCodesApi["DEPOSIT_AUTHORIZE_FAIL"] = "deposit_authorize_fail";
    ProjectExceptionCodesApi["DEPOSIT_USER_ID_INVALID"] = "deposit_user_id_invalid";
    ProjectExceptionCodesApi["CHARGE_FAIL"] = "charge_fail";
    ProjectExceptionCodesApi["CHARGE_FAIL_NOT_SUPPORTED"] = "charge_fail_not_supported";
    ProjectExceptionCodesApi["CHARGE_PENDING"] = "charge_pending";
    ProjectExceptionCodesApi["CHARGE_VALIDATION_FAIL"] = "charge_validation_fail";
    ProjectExceptionCodesApi["REFUND_FAIL"] = "refund_fail";
    ProjectExceptionCodesApi["REFUND_VALIDATION_FAIL"] = "refund_validation_fail";
    ProjectExceptionCodesApi["TRANSACTION_VALIDATION_FAIL"] = "transaction_validation_fail";
    ProjectExceptionCodesApi["TRANSACTION_NOT_FOUND"] = "transaction_not_found";
    ProjectExceptionCodesApi["REFUND_CHARGE_FAIL"] = "refund_charge_fail";
    ProjectExceptionCodesApi["PAY_INVOICE_UNAUTHORIZED_REQUEST"] = "pay_invoice_unauthorized_request";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_INCOMPLETE_USER_DETAILS"] = "pay_invoice_fail_incomplete_user_details";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_ESCROW_INVOICE_CLEARED"] = "pay_invoice_fail_escrow_invoice_cleared";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_ESCROW_INVOICE_CANCELLED"] = "pay_invoice_fail_escrow_invoice_cancelled";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_UNABLE_TO_RELEASE_ESCROW_MILESTONE"] = "pay_invoice_fail_unable_to_release_escrow_milestone";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_INVOICE_IS_PAID_OR_WITHDRAWN"] = "pay_invoice_fail_invoice_is_paid_or_withdrawn";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_MISMATCH_INVOICE_AMOUNT"] = "pay_invoice_fail_mismatch_invoice_amount";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_PAYMENT_AMOUNT_GREATER_THAN_INVOICE_AMOUNT"] = "pay_invoice_fail_payment_amount_greater_than_invoice_amount";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_INSUFFICIENT_FUNDS"] = "pay_invoice_fail_insufficient_funds";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_INVALID_MILESTONE"] = "pay_invoice_fail_invalid_milestone";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_INVALID_INVOICE"] = "pay_invoice_fail_invalid_invoice";
    ProjectExceptionCodesApi["PAY_INVOICE_FAIL_SERVER_ERROR"] = "pay_invoice_fail_server_error";
    ProjectExceptionCodesApi["CART_PAYMENT_REQUIRED"] = "cart_payment_required";
    ProjectExceptionCodesApi["DEPOSIT_APPROVAL_REQUIRED"] = "deposit_approval_required";
    ProjectExceptionCodesApi["INVALID_ENTRY_ID"] = "invalid_entry_id";
    ProjectExceptionCodesApi["INVALID_ENTRY_OWNER_ID"] = "invalid_entry_owner_id";
    ProjectExceptionCodesApi["INVALID_ENTRY_RATING"] = "invalid_entry_rating";
    ProjectExceptionCodesApi["JOB_COMPLETION_NOT_FOUND"] = "job_completion_not_found";
    ProjectExceptionCodesApi["ENTRY_OWNER_NOT_LOADED"] = "entry_owner_not_loaded";
    ProjectExceptionCodesApi["ENTRY_AWARD_NOT_ACTIVE"] = "entry_award_not_active";
    ProjectExceptionCodesApi["CREATE_PRIZE_NOT_ALLOWED"] = "create_prize_not_allowed";
    ProjectExceptionCodesApi["ENTRY_AWARD_INSUFFICIENT_FUNDS"] = "entry_award_insufficient_funds";
    ProjectExceptionCodesApi["ENTRY_NOT_ACTIVE"] = "entry_not_active";
    ProjectExceptionCodesApi["CONTEST_ID_REQUIRED"] = "contest_id_required";
    ProjectExceptionCodesApi["CONTEST_NAME_REQUIRED"] = "contest_name_required";
    ProjectExceptionCodesApi["CONTEST_CURRENCY_REQUIRED"] = "contest_currency_required";
    ProjectExceptionCodesApi["CONTEST_USER_ID_REQUIRED"] = "contest_user_id_required";
    ProjectExceptionCodesApi["INVALID_CONTEST_TYPE"] = "invalid_contest_type";
    ProjectExceptionCodesApi["INVALID_CONTEST_PRIZE"] = "invalid_contest_prize";
    ProjectExceptionCodesApi["INVALID_CONTEST_DURATION"] = "invalid_contest_duration";
    ProjectExceptionCodesApi["INVALID_CONTEST_CURRENCY"] = "invalid_contest_currency";
    ProjectExceptionCodesApi["CONTEST_CATEGORY_INSERT_FAILED"] = "contest_category_insert_failed";
    ProjectExceptionCodesApi["CONTEST_FILE_INSERT_FAILED"] = "contest_file_insert_failed";
    ProjectExceptionCodesApi["CONTEST_FILE_DELETE_FAILED"] = "contest_file_delete_failed";
    ProjectExceptionCodesApi["CONTEST_CREATE_NOT_ALLOWED"] = "contest_create_not_allowed";
    ProjectExceptionCodesApi["CONTEST_CREATE_INSUFFICIENT_FUNDS"] = "contest_create_insufficient_funds";
    ProjectExceptionCodesApi["CONTEST_PRIZE_LESS_THAN_MINIMUM_BUDGET"] = "contest_prize_less_than_minimum_budget";
    ProjectExceptionCodesApi["CONTEST_NAME_EXISTS"] = "contest_name_exists";
    ProjectExceptionCodesApi["CONTEST_ALREADY_JOINED"] = "contest_already_joined";
    ProjectExceptionCodesApi["CONTEST_HOLDER_CANNOT_JOIN"] = "contest_holder_cannot_join";
    ProjectExceptionCodesApi["CONTEST_LOAD_FAILED"] = "contest_load_failed";
    ProjectExceptionCodesApi["CONTEST_JOIN_FAILED"] = "contest_join_failed";
    ProjectExceptionCodesApi["USER_LOAD_FAILED"] = "user_load_failed";
    ProjectExceptionCodesApi["REVIEW_NOT_FOUND"] = "review_not_found";
    ProjectExceptionCodesApi["CONTESTS_BLACKLISTED_USER"] = "contests_blacklisted_user";
    ProjectExceptionCodesApi["MESSAGE_REQUIRED"] = "message_required";
    ProjectExceptionCodesApi["ENTRY_ID_HASHTAG_LIMIT_EXCEEDED"] = "entry_id_hashtag_limit_exceeded";
    ProjectExceptionCodesApi["MESSAGE_LENGTH_LIMIT_EXCEEDED"] = "message_length_limit_exceeded";
    ProjectExceptionCodesApi["PRIVATE_MESSAGE_RECEIVER_REQUIRED"] = "private_message_receiver_required";
    ProjectExceptionCodesApi["PRIVATE_MESSAGE_ONLY_FOR_CONTEST_HOLDER"] = "private_message_only_for_contest_holder";
    ProjectExceptionCodesApi["POST_MESSAGE_FAILED"] = "post_message_failed";
    ProjectExceptionCodesApi["HANDOVER_ACCESS_DENIED"] = "handover_access_denied";
    ProjectExceptionCodesApi["CONTEST_LOCKED"] = "contest_locked";
    ProjectExceptionCodesApi["CONTEST_DELETED"] = "contest_deleted";
    ProjectExceptionCodesApi["ENTRY_ID_REQUIRED"] = "entry_id_required";
    ProjectExceptionCodesApi["ENTRY_NOT_WINNER"] = "entry_not_winner";
    ProjectExceptionCodesApi["HANDOVER_CANCELED"] = "handover_canceled";
    ProjectExceptionCodesApi["ANNOTATIONS_ALLOWED_ONLY_FROM_CONTEST_HOLDER"] = "annotations_allowed_only_from_contest_holder";
    ProjectExceptionCodesApi["ENTRY_UPLOAD_LIMIT_REACHED"] = "entry_upload_limit_reached";
    ProjectExceptionCodesApi["CONTEST_NOT_FOUND"] = "contest_not_found";
    ProjectExceptionCodesApi["ENTRY_NOT_FOUND"] = "entry_not_found";
    ProjectExceptionCodesApi["ENTRY_FILE_NOT_FOUND"] = "entry_file_not_found";
    ProjectExceptionCodesApi["POINT_OUT_OF_BOUNDS"] = "point_out_of_bounds";
    ProjectExceptionCodesApi["ENTRY_NOT_IN_CONTEST"] = "entry_not_in_contest";
    ProjectExceptionCodesApi["MESSAGE_NOT_IN_BOARD"] = "message_not_in_board";
    ProjectExceptionCodesApi["THREAD_DEPTH_LIMIT_EXCEEDED"] = "thread_depth_limit_exceeded";
    ProjectExceptionCodesApi["INVALID_MESSAGE_BOARD"] = "invalid_message_board";
    ProjectExceptionCodesApi["FEATURE_NOT_SUPPORTED"] = "feature_not_supported";
    ProjectExceptionCodesApi["USER_NOT_PARTICIPANT"] = "user_not_participant";
    ProjectExceptionCodesApi["CONTEST_CLOSED"] = "contest_closed";
    ProjectExceptionCodesApi["USER_NOT_CONTEST_OWNER"] = "user_not_contest_owner";
    ProjectExceptionCodesApi["CONTEST_DESCRIPTION_MAX_LENGTH_EXCEEDED"] = "contest_description_max_length_exceeded";
    ProjectExceptionCodesApi["COLLABORATION_NOT_FOUND"] = "collaboration_not_found";
    ProjectExceptionCodesApi["CONTEST_MESSAGE_ID_REQUIRED"] = "contest_message_id_required";
    ProjectExceptionCodesApi["CONTEST_MESSAGE_ACCESS_DENIED"] = "contest_message_access_denied";
    ProjectExceptionCodesApi["CONTEST_MESSAGE_NOT_FOUND"] = "contest_message_not_found";
    ProjectExceptionCodesApi["CONTESTS_ENTERED_LIMIT_EXCEEDED"] = "contests_entered_limit_exceeded";
    ProjectExceptionCodesApi["PROJECT_NOT_OWNED_BY_USER"] = "project_not_owned_by_user";
    ProjectExceptionCodesApi["PROJECT_NEITHER_OPEN_NOR_FROZEN"] = "project_neither_open_nor_frozen";
    ProjectExceptionCodesApi["ENTRY_BUY_TRANSACTION_ERROR"] = "entry_buy_transaction_error";
    ProjectExceptionCodesApi["ENTRY_BUY_WITHOUT_WINNER"] = "entry_buy_without_winner";
    ProjectExceptionCodesApi["ENTRY_BUY_NOT_ACTIVE"] = "entry_buy_not_active";
    ProjectExceptionCodesApi["ENTRY_BUY_INSUFFICIENT_FUNDS"] = "entry_buy_insufficient_funds";
    ProjectExceptionCodesApi["ENTRY_BUYER_NOT_LOADED"] = "entry_buyer_not_loaded";
    ProjectExceptionCodesApi["ENTRY_AWARD_HAS_WINNER"] = "entry_award_has_winner";
    ProjectExceptionCodesApi["CONTEST_USER_RESTRICTED"] = "contest_user_restricted";
    ProjectExceptionCodesApi["CONTEST_ELIMINATED_USER"] = "contest_eliminated_user";
    ProjectExceptionCodesApi["USER_DUPLICATE_ACCOUNT"] = "user_duplicate_account";
    ProjectExceptionCodesApi["ENTRY_IMAGE_SAVE_FAILED"] = "entry_image_save_failed";
    ProjectExceptionCodesApi["ENTRY_TEXT_SAVE_FAILED"] = "entry_text_save_failed";
    ProjectExceptionCodesApi["ENTRY_VIDEO_SAVE_FAILED"] = "entry_video_save_failed";
    ProjectExceptionCodesApi["ENTRY_IMAGE_RESOLUTION_LIMIT_EXCEEDED"] = "entry_image_resolution_limit_exceeded";
    ProjectExceptionCodesApi["ENTRY_IMAGE_INVALID"] = "entry_image_invalid";
    ProjectExceptionCodesApi["ENTRY_VIDEO_INVALID"] = "entry_video_invalid";
    ProjectExceptionCodesApi["ENTRY_TEXT_INVALID"] = "entry_text_invalid";
    ProjectExceptionCodesApi["ENTRY_THUMBNAIL_CREATION_FAILED"] = "entry_thumbnail_creation_failed";
    ProjectExceptionCodesApi["ENTRY_INVALID_SELL_PRICE"] = "entry_invalid_sell_price";
    ProjectExceptionCodesApi["ENTRY_CREATE_INSUFFICIENT_FUNDS"] = "entry_create_insufficient_funds";
    ProjectExceptionCodesApi["CONTEST_ENTRANT_INCOMPLETE_REQUIREMENTS"] = "contest_entrant_incomplete_requirements";
    ProjectExceptionCodesApi["HANDOVER_INVALID_FULL_NAME"] = "handover_invalid_full_name";
    ProjectExceptionCodesApi["HANDOVER_INVALID_PHONE_NUMBER"] = "handover_invalid_phone_number";
    ProjectExceptionCodesApi["HANDOVER_INVALID_ADDRESS"] = "handover_invalid_address";
    ProjectExceptionCodesApi["HANDOVER_INVALID_COUNTRY_CODE"] = "handover_invalid_country_code";
    ProjectExceptionCodesApi["HANDOVER_INVALID_STATE_CODE"] = "handover_invalid_state_code";
    ProjectExceptionCodesApi["HANDOVER_INVALID_CITY"] = "handover_invalid_city";
    ProjectExceptionCodesApi["HANDOVER_SIGNED_CONTRACT"] = "handover_signed_contract";
    ProjectExceptionCodesApi["HANDOVER_INVALID_INPUT"] = "handover_invalid_input";
    ProjectExceptionCodesApi["HANDOVER_NOT_FOUND"] = "handover_not_found";
    ProjectExceptionCodesApi["HANDOVER_NO_FILES_UPLOADED"] = "handover_no_files_uploaded";
    ProjectExceptionCodesApi["HANDOVER_UNDER_DISPUTE"] = "handover_under_dispute";
    ProjectExceptionCodesApi["HANDOVER_CONFIRMED"] = "handover_confirmed";
    ProjectExceptionCodesApi["HANDOVER_CONTRACT_NOT_SIGNED"] = "handover_contract_not_signed";
    ProjectExceptionCodesApi["HANDOVER_FILES_NOT_CONFIRMED"] = "handover_files_not_confirmed";
    ProjectExceptionCodesApi["HANDOVER_ENTRY_NOT_WON"] = "handover_entry_not_won";
    ProjectExceptionCodesApi["HANDOVER_RELEASE_PRIZE_FORBIDDEN"] = "handover_release_prize_forbidden";
    ProjectExceptionCodesApi["CONTEST_NOT_ACTIVE"] = "contest_not_active";
    ProjectExceptionCodesApi["CONTEST_NEED_EXTENDED_UPGRADE"] = "contest_need_extended_upgrade";
    ProjectExceptionCodesApi["CONTEST_PRIZE_HIGHER_THAN_UPDATED_PRIZE"] = "contest_prize_higher_than_updated_prize";
    ProjectExceptionCodesApi["CONTEST_UPDATE_INSUFFICIENT_FUNDS"] = "contest_update_insufficient_funds";
    ProjectExceptionCodesApi["CONTEST_NEED_BOTH_EXTENDED_AND_EXTENDED_LENGTH"] = "contest_need_both_extended_and_extended_length";
    ProjectExceptionCodesApi["CONTEST_SKILL_REQUIRED"] = "contest_skill_required";
    ProjectExceptionCodesApi["CONTEST_EXCEEDS_MAX_SKILLS"] = "contest_exceeds_max_skills";
    ProjectExceptionCodesApi["CONTEST_ACCEPTED_FILE_FORMATS_REQUIRED"] = "contest_accepted_file_formats_required";
    ProjectExceptionCodesApi["CONTEST_NOT_OWNED_BY_USER"] = "contest_not_owned_by_user";
    ProjectExceptionCodesApi["PREHIRE_GET_DAO_FAILED"] = "prehire_get_dao_failed";
    ProjectExceptionCodesApi["PREHIRE_CREATE_DAO_FAILED"] = "prehire_create_dao_failed";
    ProjectExceptionCodesApi["PREHIRE_UPDATE_DAO_FAILED"] = "prehire_update_dao_failed";
    ProjectExceptionCodesApi["PREHIRE_NOT_IN_TEST"] = "prehire_not_in_test";
    ProjectExceptionCodesApi["PREHIRE_SAME_USER"] = "prehire_same_user";
    ProjectExceptionCodesApi["PREHIRE_EMPLOYER_NOT_FOUND"] = "prehire_employer_not_found";
    ProjectExceptionCodesApi["PREHIRE_FREELANCER_NOT_FOUND"] = "prehire_freelancer_not_found";
    ProjectExceptionCodesApi["TEAM_SELF_INVITATION"] = "team_self_invitation";
    ProjectExceptionCodesApi["SPAM_IMPACT_CRITERIA_MET"] = "spam_impact_criteria_met";
    ProjectExceptionCodesApi["IIN_INVALID"] = "iin_invalid";
    ProjectExceptionCodesApi["PROJECT_LANGUAGE_CRITERIA_NOT_MET"] = "project_language_criteria_not_met";
    ProjectExceptionCodesApi["PROJECT_MISSING_IP_CONTRACT_UPGRADE"] = "project_missing_ip_contract_upgrade";
    ProjectExceptionCodesApi["MILESTONE_CANCEL_REQUEST_MILESTONE_NOT_FROZEN"] = "milestone_cancel_request_milestone_not_frozen";
    ProjectExceptionCodesApi["MILESTONE_CANCEL_REQUEST_ALREADY_PENDING"] = "milestone_cancel_request_already_pending";
    ProjectExceptionCodesApi["MILESTONE_CANCEL_REQUEST_NOT_FOUND"] = "milestone_cancel_request_not_found";
    ProjectExceptionCodesApi["POOL_NOT_FOUND"] = "pool_not_found";
    ProjectExceptionCodesApi["PROFILE_INCOMPLETE"] = "profile_incomplete";
    ProjectExceptionCodesApi["KYC_REQUIRED"] = "kyc_required";
    ProjectExceptionCodesApi["ESCROWCOM_ACCOUNT_UNLINKED"] = "escrowcom_account_unlinked";
    ProjectExceptionCodesApi["MILESTONE_RELEASED"] = "milestone_released";
    ProjectExceptionCodesApi["NOT_INVITED_NOT_PREFERRED"] = "not_invited_not_preferred";
    ProjectExceptionCodesApi["BID_EDIT_REQUEST_DUPLICATE"] = "bid_edit_request_duplicate";
    ProjectExceptionCodesApi["BID_EDIT_REQUEST_INVALID"] = "bid_edit_request_invalid";
    ProjectExceptionCodesApi["TIME_TRACKING_SESSION_FINALISED"] = "time_tracking_session_finalised";
    ProjectExceptionCodesApi["TIME_TRACKING_SESSION_NOT_FOUND"] = "time_tracking_session_not_found";
    ProjectExceptionCodesApi["MANUAL_TIME_TRACKING_NOT_ALLOWED"] = "manual_time_tracking_not_allowed";
    ProjectExceptionCodesApi["TIME_TRACKING_CANNOT_EXCEED_WEEKLY_LIMIT"] = "time_tracking_cannot_exceed_weekly_limit";
    ProjectExceptionCodesApi["BID_ALREADY_SEALED"] = "bid_already_sealed";
    ProjectExceptionCodesApi["MILESTONE_INVOICE_AMOUNT_MISMATCH"] = "milestone_invoice_amount_mismatch";
    ProjectExceptionCodesApi["INVALID_INVOICE_FOR_PROJECT"] = "invalid_invoice_for_project";
    ProjectExceptionCodesApi["INVOICE_NOT_UNPAID"] = "invoice_not_unpaid";
    ProjectExceptionCodesApi["INVOICE_HAS_LINKED_MILESTONE"] = "invoice_has_linked_milestone";
    ProjectExceptionCodesApi["REVIEW_PERIOD_EXPIRED"] = "review_period_expired";
    ProjectExceptionCodesApi["HIREME_HOURLY_RATE_BELOW_MINIMUM"] = "hireme_hourly_rate_below_minimum";
    ProjectExceptionCodesApi["INVOICE_PAYMENT_REQUIRED"] = "invoice_payment_required";
    ProjectExceptionCodesApi["PROJECT_END_BIDDING_FAILED"] = "project_end_bidding_failed";
    ProjectExceptionCodesApi["TIME_TRACKING_SESSION_ALREADY_STARTED"] = "time_tracking_session_already_started";
    ProjectExceptionCodesApi["PROJECT_HAS_PENDING_AWARD"] = "project_has_pending_award";
    ProjectExceptionCodesApi["PROJECT_HAS_PENDING_MILESTONE"] = "project_has_pending_milestone";
    ProjectExceptionCodesApi["PROJECT_NOT_DELETABLE"] = "project_not_deletable";
    ProjectExceptionCodesApi["TIME_TRACKING_SESSION_ALREADY_STOPPED"] = "time_tracking_session_already_stopped";
    ProjectExceptionCodesApi["METADATA_FIELD_NOT_FOUND"] = "metadata_field_not_found";
    ProjectExceptionCodesApi["METADATA_FIELD_DISABLED"] = "metadata_field_disabled";
    ProjectExceptionCodesApi["METADATA_FIELD_VALUE_INVALID"] = "metadata_field_value_invalid";
    ProjectExceptionCodesApi["METADATA_FIELD_TYPE_INVALID"] = "metadata_field_type_invalid";
    ProjectExceptionCodesApi["PROJECT_BOOKMARK_LIMIT_REACHED"] = "project_bookmark_limit_reached";
    ProjectExceptionCodesApi["QUOTATION_FUND_INSUFFICIENT"] = "quotation_fund_insufficient";
    ProjectExceptionCodesApi["QUOTATION_ITEM_AMOUNT_TOO_LOW"] = "quotation_item_amount_too_low";
    ProjectExceptionCodesApi["HIREME_QUOTATION_INVALID"] = "hireme_quotation_invalid";
    ProjectExceptionCodesApi["QUOTATION_CONTEXT_TYPE_INVALID"] = "quotation_context_type_invalid";
    ProjectExceptionCodesApi["QUOTATION_EXPIRED"] = "quotation_expired";
    ProjectExceptionCodesApi["QUOTATION_IS_INVALID"] = "quotation_is_invalid";
    ProjectExceptionCodesApi["LINKED_EXTERNAL_PROJECT_UPDATE_NOT_ALLOWED"] = "linked_external_project_update_not_allowed";
    ProjectExceptionCodesApi["LINKED_EXTERNAL_PROJECT_INVALID"] = "linked_external_project_invalid";
    ProjectExceptionCodesApi["LINKED_EXTERNAL_PROJECT_ALREADY_EXISTS"] = "linked_external_project_already_exists";
    ProjectExceptionCodesApi["BID_PITCH_NOT_FOUND"] = "bid_pitch_not_found";
    ProjectExceptionCodesApi["CARD_AUTHENTICATION_REQUIRED"] = "card_authentication_required";
    ProjectExceptionCodesApi["DELIVERY_ITEMS_BELONG_TO_OTHER_PROJECT"] = "delivery_items_belong_to_other_project";
    ProjectExceptionCodesApi["DELIVERY_ITEMS_INVALID"] = "delivery_items_invalid";
    ProjectExceptionCodesApi["PROJECT_HAS_ACTIVE_BIDS"] = "project_has_active_bids";
    ProjectExceptionCodesApi["PAYOUT_LIMIT_EXEMPTION_DUPLICATE"] = "payout_limit_exemption_duplicate";
    ProjectExceptionCodesApi["PAYOUT_LIMIT_EXEMPTION_NOT_FOUND"] = "payout_limit_exemption_not_found";
})(ProjectExceptionCodesApi || (ProjectExceptionCodesApi = {}));
export var ProjectStatusApi;
(function (ProjectStatusApi) {
    ProjectStatusApi["ACTIVE"] = "active";
    ProjectStatusApi["CLOSED"] = "closed";
    ProjectStatusApi["FROZEN"] = "frozen";
    ProjectStatusApi["DRAFT"] = "draft";
    ProjectStatusApi["PENDING"] = "pending";
    ProjectStatusApi["REJECTED"] = "rejected";
})(ProjectStatusApi || (ProjectStatusApi = {}));
export var ProjectSubStatusApi;
(function (ProjectSubStatusApi) {
    ProjectSubStatusApi["CLOSED_EXPIRED"] = "closed_expired";
    ProjectSubStatusApi["CANCEL_ADMIN"] = "cancel_admin";
    ProjectSubStatusApi["CANCEL_BUYER"] = "cancel_buyer";
    ProjectSubStatusApi["CLOSED_AWARDED"] = "closed_awarded";
    ProjectSubStatusApi["FROZEN_TIMEOUT"] = "frozen_timeout";
    ProjectSubStatusApi["FROZEN_AWARDED"] = "frozen_awarded";
    ProjectSubStatusApi["CANCEL_SELLER"] = "cancel_seller";
})(ProjectSubStatusApi || (ProjectSubStatusApi = {}));
export var BidEditRequestStatusApi;
(function (BidEditRequestStatusApi) {
    BidEditRequestStatusApi["PENDING"] = "pending";
    BidEditRequestStatusApi["ACCEPTED"] = "accepted";
    BidEditRequestStatusApi["DECLINED"] = "declined";
})(BidEditRequestStatusApi || (BidEditRequestStatusApi = {}));
export var BidAwardStatusApi;
(function (BidAwardStatusApi) {
    BidAwardStatusApi["AWARDED"] = "awarded";
    BidAwardStatusApi["REJECTED"] = "rejected";
    BidAwardStatusApi["REVOKED"] = "revoked";
    BidAwardStatusApi["PENDING"] = "pending";
    BidAwardStatusApi["CANCELED"] = "canceled";
})(BidAwardStatusApi || (BidAwardStatusApi = {}));
export var BidPaidStatusApi;
(function (BidPaidStatusApi) {
    BidPaidStatusApi["UNPAID"] = "unpaid";
    BidPaidStatusApi["PARTLY_PAID"] = "partly_paid";
    BidPaidStatusApi["FULLY_PAID"] = "fully_paid";
})(BidPaidStatusApi || (BidPaidStatusApi = {}));
export var BidCompleteStatusApi;
(function (BidCompleteStatusApi) {
    BidCompleteStatusApi["PENDING"] = "pending";
    BidCompleteStatusApi["INCOMPLETE"] = "incomplete";
    BidCompleteStatusApi["COMPLETE"] = "complete";
})(BidCompleteStatusApi || (BidCompleteStatusApi = {}));
export var ProjectTitleEditRequestStatusApi;
(function (ProjectTitleEditRequestStatusApi) {
    ProjectTitleEditRequestStatusApi["PENDING"] = "pending";
    ProjectTitleEditRequestStatusApi["ACCEPTED"] = "accepted";
    ProjectTitleEditRequestStatusApi["REJECTED"] = "rejected";
})(ProjectTitleEditRequestStatusApi || (ProjectTitleEditRequestStatusApi = {}));
export var ProjectTitleEditRequestActionApi;
(function (ProjectTitleEditRequestActionApi) {
    ProjectTitleEditRequestActionApi["ACCEPT"] = "accept";
    ProjectTitleEditRequestActionApi["REJECT"] = "reject";
})(ProjectTitleEditRequestActionApi || (ProjectTitleEditRequestActionApi = {}));
export var ReviewStatusApi;
(function (ReviewStatusApi) {
    ReviewStatusApi["PENDING"] = "pending";
    ReviewStatusApi["AWAITING"] = "awaiting";
    ReviewStatusApi["ACTIVE"] = "active";
    ReviewStatusApi["WITHDRAWN"] = "withdrawn";
    ReviewStatusApi["HIDDEN"] = "hidden";
    ReviewStatusApi["DENIED"] = "denied";
    ReviewStatusApi["EXPIRED"] = "expired";
})(ReviewStatusApi || (ReviewStatusApi = {}));
export var ReviewProjectStatusApi;
(function (ReviewProjectStatusApi) {
    ReviewProjectStatusApi["COMPLETE"] = "complete";
    ReviewProjectStatusApi["INCOMPLETE"] = "incomplete";
})(ReviewProjectStatusApi || (ReviewProjectStatusApi = {}));
export var ReviewTypeApi;
(function (ReviewTypeApi) {
    ReviewTypeApi["PROJECT"] = "project";
    ReviewTypeApi["CONTEST"] = "contest";
    ReviewTypeApi["INVOICE"] = "invoice";
})(ReviewTypeApi || (ReviewTypeApi = {}));
export var ReviewActionTypeApi;
(function (ReviewActionTypeApi) {
    ReviewActionTypeApi["FEATURE"] = "feature";
    ReviewActionTypeApi["UNFEATURE"] = "unfeature";
})(ReviewActionTypeApi || (ReviewActionTypeApi = {}));
export var ProjectTypeApi;
(function (ProjectTypeApi) {
    ProjectTypeApi["FIXED"] = "fixed";
    ProjectTypeApi["HOURLY"] = "hourly";
})(ProjectTypeApi || (ProjectTypeApi = {}));
export var ProjectDurationApi;
(function (ProjectDurationApi) {
    ProjectDurationApi["LESS_THAN_ONE_WEEK"] = "less_than_one_week";
    ProjectDurationApi["ONE_TO_FOUR_WEEKS"] = "one_to_four_weeks";
    ProjectDurationApi["ONE_TO_THREE_MONTHS"] = "one_to_three_months";
    ProjectDurationApi["THREE_TO_SIX_MONTHS"] = "three_to_six_months";
    ProjectDurationApi["ONGOING"] = "ongoing";
    ProjectDurationApi["UNSPECIFIED"] = "unspecified";
    ProjectDurationApi["UNKNOWN"] = "unknown";
})(ProjectDurationApi || (ProjectDurationApi = {}));
export var ProjectTemplateQuestionTextStyleApi;
(function (ProjectTemplateQuestionTextStyleApi) {
    ProjectTemplateQuestionTextStyleApi["RADIO"] = "radio";
    ProjectTemplateQuestionTextStyleApi["CHECKBOX"] = "checkbox";
    ProjectTemplateQuestionTextStyleApi["FREEFORM"] = "freeform";
    ProjectTemplateQuestionTextStyleApi["SLIDER"] = "slider";
})(ProjectTemplateQuestionTextStyleApi || (ProjectTemplateQuestionTextStyleApi = {}));
export var ProjectLocalizabilityApi;
(function (ProjectLocalizabilityApi) {
    ProjectLocalizabilityApi["LOCAL_ONLY"] = "local_only";
    ProjectLocalizabilityApi["REMOTE_ONLY"] = "remote_only";
    ProjectLocalizabilityApi["LOCAL_OR_REMOTE"] = "local_or_remote";
})(ProjectLocalizabilityApi || (ProjectLocalizabilityApi = {}));
export var DeliveryTypeApi;
(function (DeliveryTypeApi) {
    DeliveryTypeApi["GENERAL"] = "general";
    DeliveryTypeApi["HOTSHOT"] = "hotshot";
    DeliveryTypeApi["ESTIMATE_ONLY"] = "estimate_only";
    DeliveryTypeApi["PROJECT"] = "project";
})(DeliveryTypeApi || (DeliveryTypeApi = {}));
export var EnterpriseLinkedProjectsApprovalStatusApi;
(function (EnterpriseLinkedProjectsApprovalStatusApi) {
    EnterpriseLinkedProjectsApprovalStatusApi["PENDING"] = "pending";
    EnterpriseLinkedProjectsApprovalStatusApi["APPROVED"] = "approved";
    EnterpriseLinkedProjectsApprovalStatusApi["REJECTED"] = "rejected";
})(EnterpriseLinkedProjectsApprovalStatusApi || (EnterpriseLinkedProjectsApprovalStatusApi = {}));
export var CopilotEnquirySourceApi;
(function (CopilotEnquirySourceApi) {
    CopilotEnquirySourceApi["UNKNOWN"] = "unknown";
    CopilotEnquirySourceApi["LANDING_PAGE"] = "landing_page";
    CopilotEnquirySourceApi["PROJECT_VIEW_PAGE"] = "project_view_page";
    CopilotEnquirySourceApi["RECRUITER_RICH_MESSAGE"] = "recruiter_rich_message";
})(CopilotEnquirySourceApi || (CopilotEnquirySourceApi = {}));
export var PrepaidMilestoneStatusApi;
(function (PrepaidMilestoneStatusApi) {
    PrepaidMilestoneStatusApi["ERROR"] = "error";
    PrepaidMilestoneStatusApi["CANCELLED"] = "cancelled";
    PrepaidMilestoneStatusApi["TO_BE_PREPARED"] = "to_be_prepared";
    PrepaidMilestoneStatusApi["LOCKED"] = "locked";
    PrepaidMilestoneStatusApi["CLEARED"] = "cleared";
})(PrepaidMilestoneStatusApi || (PrepaidMilestoneStatusApi = {}));
export var MilestoneStatusApi;
(function (MilestoneStatusApi) {
    MilestoneStatusApi["DISPUTED"] = "disputed";
    MilestoneStatusApi["REQUESTED_RELEASE"] = "requested_release";
    MilestoneStatusApi["PENDING"] = "pending";
    MilestoneStatusApi["FROZEN"] = "frozen";
    MilestoneStatusApi["CLEARED"] = "cleared";
    MilestoneStatusApi["CANCELED"] = "canceled";
    MilestoneStatusApi["PENDING_RECIPIENT_KYC"] = "pending_recipient_kyc";
    MilestoneStatusApi["PENDING_CLEARANCE"] = "pending_clearance";
    MilestoneStatusApi["UNKNOWN"] = "unknown";
})(MilestoneStatusApi || (MilestoneStatusApi = {}));
export var ExpertGuaranteeStatusApi;
(function (ExpertGuaranteeStatusApi) {
    ExpertGuaranteeStatusApi["DISPUTED"] = "disputed";
    ExpertGuaranteeStatusApi["REQUESTED_RELEASE"] = "requested_release";
    ExpertGuaranteeStatusApi["LOCKED"] = "locked";
    ExpertGuaranteeStatusApi["RELEASED"] = "released";
    ExpertGuaranteeStatusApi["LIQUIDATED"] = "liquidated";
    ExpertGuaranteeStatusApi["ADMIN_REFUNDED"] = "admin_refunded";
    ExpertGuaranteeStatusApi["UNKNOWN"] = "unknown";
})(ExpertGuaranteeStatusApi || (ExpertGuaranteeStatusApi = {}));
export var ProjectTaskStatusApi;
(function (ProjectTaskStatusApi) {
    ProjectTaskStatusApi["REQUESTED"] = "requested";
    ProjectTaskStatusApi["REJECTED"] = "rejected";
    ProjectTaskStatusApi["IN_PROGRESS"] = "in_progress";
    ProjectTaskStatusApi["AWAITING_REVIEW"] = "awaiting_review";
    ProjectTaskStatusApi["COMPLETED"] = "completed";
    ProjectTaskStatusApi["CANCELLED"] = "cancelled";
    ProjectTaskStatusApi["UNKNOWN"] = "unknown";
})(ProjectTaskStatusApi || (ProjectTaskStatusApi = {}));
export var ProjectTaskCommentActionApi;
(function (ProjectTaskCommentActionApi) {
    ProjectTaskCommentActionApi["NO_ACTION"] = "no_action";
    ProjectTaskCommentActionApi["CREATE"] = "create";
    ProjectTaskCommentActionApi["REQUEST"] = "request";
    ProjectTaskCommentActionApi["REJECT_REQUEST"] = "reject_request";
    ProjectTaskCommentActionApi["APPROVE_REQUEST"] = "approve_request";
    ProjectTaskCommentActionApi["REQUEST_REVIEW"] = "request_review";
    ProjectTaskCommentActionApi["REQUEST_CHANGES"] = "request_changes";
    ProjectTaskCommentActionApi["COMPLETE"] = "complete";
    ProjectTaskCommentActionApi["CANCEL"] = "cancel";
    ProjectTaskCommentActionApi["UNKNOWN"] = "unknown";
})(ProjectTaskCommentActionApi || (ProjectTaskCommentActionApi = {}));
export var MilestoneRequestStatusApi;
(function (MilestoneRequestStatusApi) {
    MilestoneRequestStatusApi["DELETED"] = "deleted";
    MilestoneRequestStatusApi["REJECTED"] = "rejected";
    MilestoneRequestStatusApi["PENDING"] = "pending";
    MilestoneRequestStatusApi["CREATED"] = "created";
    MilestoneRequestStatusApi["UNKNOWN"] = "unknown";
})(MilestoneRequestStatusApi || (MilestoneRequestStatusApi = {}));
export var MilestoneReasonApi;
(function (MilestoneReasonApi) {
    MilestoneReasonApi["FULL_PAYMENT"] = "full_payment";
    MilestoneReasonApi["PARTIAL_PAYMENT"] = "partial_payment";
    MilestoneReasonApi["TASK_DESCRIPTION"] = "task_description";
    MilestoneReasonApi["OTHER"] = "other";
})(MilestoneReasonApi || (MilestoneReasonApi = {}));
export var RequestedPrepaidMilestonesApi;
(function (RequestedPrepaidMilestonesApi) {
    RequestedPrepaidMilestonesApi["NONE"] = "none";
    RequestedPrepaidMilestonesApi["ONE"] = "one";
    RequestedPrepaidMilestonesApi["ALL"] = "all";
})(RequestedPrepaidMilestonesApi || (RequestedPrepaidMilestonesApi = {}));
export var ProjectUpgradeOptionsApi;
(function (ProjectUpgradeOptionsApi) {
    ProjectUpgradeOptionsApi["FEATURED"] = "featured";
    ProjectUpgradeOptionsApi["RECRUITER"] = "recruiter";
    ProjectUpgradeOptionsApi["EXTEND"] = "extend";
    ProjectUpgradeOptionsApi["URGENT"] = "urgent";
    ProjectUpgradeOptionsApi["NONPUBLIC"] = "nonpublic";
    ProjectUpgradeOptionsApi["HIDEBIDS"] = "hidebids";
    ProjectUpgradeOptionsApi["FULLTIME"] = "fulltime";
    ProjectUpgradeOptionsApi["NDA"] = "nda";
    ProjectUpgradeOptionsApi["IP_CONTRACT"] = "ip_contract";
    ProjectUpgradeOptionsApi["SUCCESS_BUNDLE"] = "success_bundle";
    ProjectUpgradeOptionsApi["NON_COMPETE"] = "non_compete";
    ProjectUpgradeOptionsApi["PROJECT_MANAGEMENT"] = "project_management";
    ProjectUpgradeOptionsApi["PF_ONLY"] = "pf_only";
    ProjectUpgradeOptionsApi["PREMIUM"] = "premium";
    ProjectUpgradeOptionsApi["ENTERPRISE"] = "enterprise";
})(ProjectUpgradeOptionsApi || (ProjectUpgradeOptionsApi = {}));
export var BidUpgradeApi;
(function (BidUpgradeApi) {
    BidUpgradeApi["HIGHLIGHT"] = "highlight";
    BidUpgradeApi["SPONSORED"] = "sponsored";
    BidUpgradeApi["SEALED"] = "sealed";
})(BidUpgradeApi || (BidUpgradeApi = {}));
export var HireMeOfferStatusApi;
(function (HireMeOfferStatusApi) {
    HireMeOfferStatusApi["PENDING"] = "pending";
    HireMeOfferStatusApi["REJECTED"] = "rejected";
    HireMeOfferStatusApi["ACCEPTED"] = "accepted";
    HireMeOfferStatusApi["EXPIRED"] = "expired";
})(HireMeOfferStatusApi || (HireMeOfferStatusApi = {}));
export var NegotiatedOfferStatusApi;
(function (NegotiatedOfferStatusApi) {
    NegotiatedOfferStatusApi["FREELANCER_PENDING"] = "freelancer_pending";
    NegotiatedOfferStatusApi["EMPLOYER_PENDING"] = "employer_pending";
    NegotiatedOfferStatusApi["EMPLOYER_ACCEPTED"] = "employer_accepted";
    NegotiatedOfferStatusApi["EMPLOYER_REQUESTED"] = "employer_requested";
    NegotiatedOfferStatusApi["EMPLOYER_REJECTED"] = "employer_rejected";
    NegotiatedOfferStatusApi["FREELANCER_REJECTED"] = "freelancer_rejected";
})(NegotiatedOfferStatusApi || (NegotiatedOfferStatusApi = {}));
export var HourlyContractBillingCycleApi;
(function (HourlyContractBillingCycleApi) {
    HourlyContractBillingCycleApi["WEEKLY"] = "weekly";
    HourlyContractBillingCycleApi["MONTHLY"] = "monthly";
})(HourlyContractBillingCycleApi || (HourlyContractBillingCycleApi = {}));
export var UserInvolvementOptionsApi;
(function (UserInvolvementOptionsApi) {
    UserInvolvementOptionsApi["HANDS_ON"] = "hands_on";
    UserInvolvementOptionsApi["COLLABORATION_MODE"] = "collaboration_mode";
    UserInvolvementOptionsApi["HANDS_OFF"] = "hands_off";
})(UserInvolvementOptionsApi || (UserInvolvementOptionsApi = {}));
export var UserTechnicalLevelOptionsApi;
(function (UserTechnicalLevelOptionsApi) {
    UserTechnicalLevelOptionsApi["TECH_WIZARD"] = "tech_wizard";
    UserTechnicalLevelOptionsApi["TECH_STARTER"] = "tech_starter";
    UserTechnicalLevelOptionsApi["EAGER_TO_LEARN"] = "eager_to_learn";
})(UserTechnicalLevelOptionsApi || (UserTechnicalLevelOptionsApi = {}));
export var BidHiddenReasonApi;
(function (BidHiddenReasonApi) {
    BidHiddenReasonApi["NOT_INTERESTING"] = "not_interesting";
    BidHiddenReasonApi["CONTACTS"] = "contacts";
    BidHiddenReasonApi["ADVERTISING"] = "advertising";
    BidHiddenReasonApi["FAKE"] = "fake";
    BidHiddenReasonApi["HARASSMENT"] = "harassment";
})(BidHiddenReasonApi || (BidHiddenReasonApi = {}));
export var ProjectLocalTimeSlotApi;
(function (ProjectLocalTimeSlotApi) {
    ProjectLocalTimeSlotApi["BEFORE_NINE"] = "before_nine";
    ProjectLocalTimeSlotApi["NINE_TO_TWELVE"] = "nine_to_twelve";
    ProjectLocalTimeSlotApi["TWELVE_TO_SIX"] = "twelve_to_six";
    ProjectLocalTimeSlotApi["AFTER_SIX"] = "after_six";
})(ProjectLocalTimeSlotApi || (ProjectLocalTimeSlotApi = {}));
export var ProjectCollaborationPermissionApi;
(function (ProjectCollaborationPermissionApi) {
    ProjectCollaborationPermissionApi["CHAT"] = "chat";
    ProjectCollaborationPermissionApi["BID_AWARD"] = "bid_award";
    ProjectCollaborationPermissionApi["MILESTONE_VIEW"] = "milestone_view";
    ProjectCollaborationPermissionApi["MILESTONE_CREATE"] = "milestone_create";
    ProjectCollaborationPermissionApi["MILESTONE_REQUEST"] = "milestone_request";
    ProjectCollaborationPermissionApi["MILESTONE_RELEASE"] = "milestone_release";
    ProjectCollaborationPermissionApi["PROJECT_DETAILS_EDIT"] = "project_details_edit";
    ProjectCollaborationPermissionApi["FILE_UPLOAD"] = "file_upload";
    ProjectCollaborationPermissionApi["COLLABORATOR_ADD"] = "collaborator_add";
    ProjectCollaborationPermissionApi["TASK_LIST_EDIT"] = "task_list_edit";
    ProjectCollaborationPermissionApi["TRACKED_HOURS_APPROVE"] = "tracked_hours_approve";
    ProjectCollaborationPermissionApi["DISPUTE_CREATE"] = "dispute_create";
    ProjectCollaborationPermissionApi["UNKNOWN"] = "unknown";
})(ProjectCollaborationPermissionApi || (ProjectCollaborationPermissionApi = {}));
export var ProjectCollaborationPermissionStatusApi;
(function (ProjectCollaborationPermissionStatusApi) {
    ProjectCollaborationPermissionStatusApi["ACTIVE"] = "active";
    ProjectCollaborationPermissionStatusApi["INACTIVE"] = "inactive";
    ProjectCollaborationPermissionStatusApi["UNKNOWN"] = "unknown";
})(ProjectCollaborationPermissionStatusApi || (ProjectCollaborationPermissionStatusApi = {}));
export var ProjectCollaborationStatusApi;
(function (ProjectCollaborationStatusApi) {
    ProjectCollaborationStatusApi["SIGNUP_PENDING"] = "signup_pending";
    ProjectCollaborationStatusApi["ACCEPT_PENDING"] = "accept_pending";
    ProjectCollaborationStatusApi["ACTIVE"] = "active";
    ProjectCollaborationStatusApi["INACTIVE"] = "inactive";
    ProjectCollaborationStatusApi["UNKNOWN"] = "unknown";
})(ProjectCollaborationStatusApi || (ProjectCollaborationStatusApi = {}));
export var ProjectCollaborationActionTypeApi;
(function (ProjectCollaborationActionTypeApi) {
    ProjectCollaborationActionTypeApi["THREAD_CREATE"] = "thread_create";
    ProjectCollaborationActionTypeApi["THREAD_MODIFY"] = "thread_modify";
    ProjectCollaborationActionTypeApi["BID_AWARD"] = "bid_award";
    ProjectCollaborationActionTypeApi["BID_REVOKE"] = "bid_revoke";
    ProjectCollaborationActionTypeApi["UNKNOWN"] = "unknown";
})(ProjectCollaborationActionTypeApi || (ProjectCollaborationActionTypeApi = {}));
export var ProjectCollaborationActionContextTypeApi;
(function (ProjectCollaborationActionContextTypeApi) {
    ProjectCollaborationActionContextTypeApi["THREAD"] = "thread";
    ProjectCollaborationActionContextTypeApi["BID"] = "bid";
    ProjectCollaborationActionContextTypeApi["UNKNOWN"] = "unknown";
})(ProjectCollaborationActionContextTypeApi || (ProjectCollaborationActionContextTypeApi = {}));
export var ProjectTextCleanStatusApi;
(function (ProjectTextCleanStatusApi) {
    ProjectTextCleanStatusApi["CLEAN"] = "clean";
    ProjectTextCleanStatusApi["CHECK"] = "check";
})(ProjectTextCleanStatusApi || (ProjectTextCleanStatusApi = {}));
export var LocationSharingStatusApi;
(function (LocationSharingStatusApi) {
    LocationSharingStatusApi["STARTED"] = "started";
    LocationSharingStatusApi["ARRIVED"] = "arrived";
    LocationSharingStatusApi["PICKED_UP"] = "picked_up";
    LocationSharingStatusApi["COMPLETED"] = "completed";
})(LocationSharingStatusApi || (LocationSharingStatusApi = {}));
export var JobsGetSortApi;
(function (JobsGetSortApi) {
    JobsGetSortApi["COUNT_BY_CATEGORY"] = "count_by_category";
})(JobsGetSortApi || (JobsGetSortApi = {}));
export var MyProjectsContestsSearchTypeApi;
(function (MyProjectsContestsSearchTypeApi) {
    MyProjectsContestsSearchTypeApi["PROJECTS"] = "projects";
    MyProjectsContestsSearchTypeApi["CONTESTS"] = "contests";
})(MyProjectsContestsSearchTypeApi || (MyProjectsContestsSearchTypeApi = {}));
export var MyProjectsContestsSearchStatusApi;
(function (MyProjectsContestsSearchStatusApi) {
    MyProjectsContestsSearchStatusApi["ALL"] = "all";
    MyProjectsContestsSearchStatusApi["OPEN"] = "open";
    MyProjectsContestsSearchStatusApi["ACTIVE"] = "active";
    MyProjectsContestsSearchStatusApi["AWARDED"] = "awarded";
    MyProjectsContestsSearchStatusApi["PAST"] = "past";
})(MyProjectsContestsSearchStatusApi || (MyProjectsContestsSearchStatusApi = {}));
export var MyProjectsContestsSearchSortFieldApi;
(function (MyProjectsContestsSearchSortFieldApi) {
    MyProjectsContestsSearchSortFieldApi["PROJECT_ID"] = "project_id";
    MyProjectsContestsSearchSortFieldApi["SUBMITDATE"] = "submitdate";
})(MyProjectsContestsSearchSortFieldApi || (MyProjectsContestsSearchSortFieldApi = {}));
export var ProjectSearchIndexApi;
(function (ProjectSearchIndexApi) {
    ProjectSearchIndexApi["ALL"] = "all";
    ProjectSearchIndexApi["ACTIVE"] = "active";
    ProjectSearchIndexApi["DELETED"] = "deleted";
})(ProjectSearchIndexApi || (ProjectSearchIndexApi = {}));
export var MilestoneCancelRequestReasonApi;
(function (MilestoneCancelRequestReasonApi) {
    MilestoneCancelRequestReasonApi["FREELANCER_DID_NOT_MEET_DEADLINE"] = "freelancer_did_not_meet_deadline";
    MilestoneCancelRequestReasonApi["ACCIDENTALLY_CREATED"] = "accidentally_created";
    MilestoneCancelRequestReasonApi["FREELANCER_DID_NOT_COMPLETE_TASK"] = "freelancer_did_not_complete_task";
    MilestoneCancelRequestReasonApi["NO_LONGER_NEEDED"] = "no_longer_needed";
    MilestoneCancelRequestReasonApi["OTHER"] = "other";
})(MilestoneCancelRequestReasonApi || (MilestoneCancelRequestReasonApi = {}));
export var MilestoneActionApi;
(function (MilestoneActionApi) {
    MilestoneActionApi["REQUEST_RELEASE"] = "request_release";
    MilestoneActionApi["CANCEL"] = "cancel";
    MilestoneActionApi["RELEASE"] = "release";
    MilestoneActionApi["UPDATE"] = "update";
    MilestoneActionApi["REQUEST_CANCEL"] = "request_cancel";
    MilestoneActionApi["REJECT_CANCEL"] = "reject_cancel";
})(MilestoneActionApi || (MilestoneActionApi = {}));
export var ProjectUpgradeFeeTaxTypeApi;
(function (ProjectUpgradeFeeTaxTypeApi) {
    ProjectUpgradeFeeTaxTypeApi["GST"] = "gst";
    ProjectUpgradeFeeTaxTypeApi["VAT"] = "vat";
})(ProjectUpgradeFeeTaxTypeApi || (ProjectUpgradeFeeTaxTypeApi = {}));
export var NetPromoterScoreSourceApi;
(function (NetPromoterScoreSourceApi) {
    NetPromoterScoreSourceApi["MILESTONE"] = "milestone";
    NetPromoterScoreSourceApi["PROJECT_COMPLETE"] = "project_complete";
    NetPromoterScoreSourceApi["INVOICE"] = "invoice";
    NetPromoterScoreSourceApi["CONTEST_ONGOING"] = "contest_ongoing";
    NetPromoterScoreSourceApi["HELPCENTER_EXPERIENCE"] = "helpcenter_experience";
    NetPromoterScoreSourceApi["CONTEST_HANDOVER"] = "contest_handover";
    NetPromoterScoreSourceApi["RICH_MESSAGE_ON_RESOLVE"] = "rich_message_on_resolve";
    NetPromoterScoreSourceApi["RICH_MESSAGE_ON_24HR"] = "rich_message_on_24hr";
    NetPromoterScoreSourceApi["SITEWIDE_EXPERIENCE_PENDING"] = "sitewide_experience_pending";
    NetPromoterScoreSourceApi["SITEWIDE_EXPERIENCE_COMPLETE"] = "sitewide_experience_complete";
    NetPromoterScoreSourceApi["KYC_COMPLETE"] = "kyc_complete";
})(NetPromoterScoreSourceApi || (NetPromoterScoreSourceApi = {}));
export var NetPromoterScoreTypeApi;
(function (NetPromoterScoreTypeApi) {
    NetPromoterScoreTypeApi["FREELANCER"] = "freelancer";
    NetPromoterScoreTypeApi["EMPLOYER"] = "employer";
    NetPromoterScoreTypeApi["CONTEST_PLATFORM"] = "contest_platform";
    NetPromoterScoreTypeApi["SUPPORT_PLATFORM"] = "support_platform";
    NetPromoterScoreTypeApi["SUPPORT_QUEUE"] = "support_queue";
    NetPromoterScoreTypeApi["SITEWIDE_EXPERIENCE"] = "sitewide_experience";
    NetPromoterScoreTypeApi["VERIFICATION_EXPERIENCE"] = "verification_experience";
})(NetPromoterScoreTypeApi || (NetPromoterScoreTypeApi = {}));
export var ServiceStatusApi;
(function (ServiceStatusApi) {
    ServiceStatusApi["PENDING"] = "pending";
    ServiceStatusApi["ACTIVE"] = "active";
    ServiceStatusApi["CLOSED"] = "closed";
})(ServiceStatusApi || (ServiceStatusApi = {}));
export var ServiceSubStatusApi;
(function (ServiceSubStatusApi) {
    ServiceSubStatusApi["TO_APPROVE"] = "to_approve";
    ServiceSubStatusApi["REJECTED"] = "rejected";
    ServiceSubStatusApi["UPDATES_REJECTED"] = "updates_rejected";
    ServiceSubStatusApi["UPDATES_NEED_REVIEW"] = "updates_need_review";
    ServiceSubStatusApi["AVAILABLE"] = "available";
    ServiceSubStatusApi["MAX_ON_HOLD"] = "max_on_hold";
    ServiceSubStatusApi["USER_ON_HOLD"] = "user_on_hold";
    ServiceSubStatusApi["CLOSED_BY_USER"] = "closed_by_user";
    ServiceSubStatusApi["CLOSED_BY_ADMIN"] = "closed_by_admin";
})(ServiceSubStatusApi || (ServiceSubStatusApi = {}));
export var ServiceSearchSortApi;
(function (ServiceSearchSortApi) {
    ServiceSearchSortApi["RECOMMENDED"] = "recommended";
    ServiceSearchSortApi["QUICKEST"] = "quickest";
    ServiceSearchSortApi["NEWEST"] = "newest";
})(ServiceSearchSortApi || (ServiceSearchSortApi = {}));
export var ProjectEndCompleteStatusApi;
(function (ProjectEndCompleteStatusApi) {
    ProjectEndCompleteStatusApi["COMPLETE"] = "complete";
    ProjectEndCompleteStatusApi["INCOMPLETE"] = "incomplete";
})(ProjectEndCompleteStatusApi || (ProjectEndCompleteStatusApi = {}));
export var OnBehalfProjectStatusApi;
(function (OnBehalfProjectStatusApi) {
    OnBehalfProjectStatusApi["PENDING"] = "pending";
    OnBehalfProjectStatusApi["POSTED"] = "posted";
    OnBehalfProjectStatusApi["REJECTED"] = "rejected";
})(OnBehalfProjectStatusApi || (OnBehalfProjectStatusApi = {}));
export var ProjectStatsStatusFilterApi;
(function (ProjectStatsStatusFilterApi) {
    ProjectStatsStatusFilterApi["ALL"] = "all";
    ProjectStatsStatusFilterApi["OPEN"] = "open";
    ProjectStatsStatusFilterApi["IN_PROGRESS"] = "in_progress";
    ProjectStatsStatusFilterApi["COMPLETED"] = "completed";
    ProjectStatsStatusFilterApi["ENDED"] = "ended";
    ProjectStatsStatusFilterApi["AWARDED"] = "awarded";
    ProjectStatsStatusFilterApi["EXPIRED_OR_REJECTED"] = "expired_or_rejected";
})(ProjectStatsStatusFilterApi || (ProjectStatsStatusFilterApi = {}));
